import { render } from "./ActivateSuccess.vue?vue&type=template&id=4ee34bf8&scoped=true"
import script from "./ActivateSuccess.vue?vue&type=script&lang=js"
export * from "./ActivateSuccess.vue?vue&type=script&lang=js"

import "./custom-activate-success.scss?vue&type=style&index=0&id=4ee34bf8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee34bf8"]])

export default __exports__